//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    import { IDcardReg } from '@/utils/regular.js'
export default {
    data(){
        return {
           applicantIdcard:'',
        }
    },
    props: {
        verify:{ // 是否验证失败
            type: Boolean,
            default() { return false; }
        },
        placeholder:{ // placeholder 文字
            type: String,
            default() { return ''; }
        },
        com_id:{ // 组件唯一id，同一页面多次引用此组件时进行区分
            type: String,
            default:'Idcard'
        },
    },
    watch:{
        applicantIdcard(val){ 
            val = val.trim();
            let idCardFlag;
            if(new RegExp("[*]").test(val)){
                idCardFlag = true
            }else{
                idCardFlag = IDcardReg(val)
            }
            // let idCardFlag = this.testid(val)
            this.$emit('IDcardEmit',{
                idcard:this.applicantIdcard,
                idCardFlag:idCardFlag
            })
        },
        verify(val){
            this.verify = val
        }
        
    },
    created() {
        this.bus.$on("idCardInputFlag", (msg)=> {
            this.applicantIdcard = msg
        });
    },
    methods:{
        testid(id) {
                var format = /^(([1][1-5])|([2][1-3])|([3][1-7])|([4][1-6])|([5][0-4])|([6][1-5])|([7][1])|([8][1-2]))\d{4}(([1][9]\d{2})|([2]\d{3}))(([0][1-9])|([1][0-2]))(([0][1-9])|([1-2][0-9])|([3][0-1]))\d{3}[0-9xX]$/;
                //号码规则校验
                if(!format.test(id)){
                    return {'status':0,'msg':'身份证号码不合规'};
                }
                //区位码校验
                //出生年月日校验   前正则限制起始年份为1900;
                var year = id.substr(6,4),//身份证年
                    month = id.substr(10,2),//身份证月
                    date = id.substr(12,2),//身份证日
                    time = Date.parse(month+'-'+date+'-'+year),//身份证日期时间戳date
                    now_time = Date.parse(new Date()),//当前时间戳
                    dates = (new Date(year,month,0)).getDate();//身份证当月天数
                if(time>now_time||date>dates){
                    // return {'status':0,'msg':'出生日期不合规'}
                    return false
                }
                //校验码判断
                var c = new Array(7,9,10,5,8,4,2,1,6,3,7,9,10,5,8,4,2);   //系数
                var b = new Array('1','0','X','9','8','7','6','5','4','3','2');  //校验码对照表
                var id_array = id.split("");
                var sum = 0;
                for(var k=0;k<17;k++){
                    sum+=parseInt(id_array[k])*parseInt(c[k]);
                }
                if(id_array[17].toUpperCase() != b[sum%11].toUpperCase()){
                    // return {'status':0,'msg':'身份证校验码不合规'}
                    return false;
                }
                // return {'status':1,'msg':'校验通过'}
                return true
            },
        cleanInfo(string = ""){
            this.applicantIdcard = string
        },
        scrollInto(){
          window.setTimeout(function () {
              const scrollHeight = document.documentElement.scrollTop || document.body.scrollTop ;
              if(scrollHeight){
                  window.scrollTo(0, Math.max(scrollHeight - 1, 0));
              }
              //console.log(Math.max(scrollHeight - 1, 0))
          }, 0);
          this.$emit('onBlur',{
              inputText:this.applicantIdcard,
              message:this.com_id
          })
            
        }
    }
}
